import NewList_grid from "../images/NewList_grid.png";
import NewList_2 from "../images/NewList_2.png";
import NewList_3 from "../images/NewList_3.png";
import D_NewList_grid from "../images/D_NewList_grid.png";

export const thirdKR = [
    {
        title1: '다양한 라벨 기능',
        subtitle1: "텍스트 라벨, 컬러 라벨, 별표 라벨 등",
        subtitle2: "다양한 그룹화로 노트를 관리해보세요.",
        img: {NewList_grid},
        img_uri: "../images/NewList_grid.png"
    },
    {
        title1: "편리한 체크리스트",
        subtitle1: "체크리스트의 추가, 삭제, 순서변경",
        subtitle2: "기능으로 리스트를 관리하세요.",
        img: {NewList_2},
        img_uri: "../images/NewList_2.png"
    },
    {
        title1: "텍스트 라벨 관리",
        subtitle1: "텍스트 라벨을 지정하면 탭으로",
        subtitle2: "그룹화하여 관리할 수 있습니다.",
        img: {NewList_3},
        img_uri: "../images/NewList_3.png"
    },
    {
        title1: "다크모드 지원",
        subtitle1: "다크모드 지원으로 설정을 통해",
        subtitle2: "자유롭게 사용할 수 있습니다.",
        img: {D_NewList_grid},
        img_uri: "../images/D_NewList_grid.png"
    },
];